<ng-container *ngIf="blogContentlet$ | async as contentlet">
  <ng-container *ngIf="currentPageURI$ | async as URI">
    <ng-container *ngIf="URI === '/blog/post/' + contentlet?.urlTitle; else blog">
      <custom-dot-cms-blog-detail
        [contentlet]="contentlet"
        [identifier]="contentlet.identifier"
      ></custom-dot-cms-blog-detail>
    </ng-container>
    <ng-template #blog>
      <custom-dot-cms-blog-post
        [contentlet]="contentlet"
        [identifier]="contentlet.identifier"
      ></custom-dot-cms-blog-post>
    </ng-template>
  </ng-container>
</ng-container>
